import { z } from 'zod';

import { StatsWindowSchema } from '../../stats/stats-range/stats-range';
import { ComparableCountSchema } from '../../stats/stats-shapes/stats-shapes';

/** One bucket of the violations chart, split by action taken. */
export const ViolationVolumePointSchema = z
  .object({
    bucket: z.string(),
    warn: z.number().int().nonnegative(),
    hideMessage: z.number().int().nonnegative(),
    suspend: z.number().int().nonnegative(),
    ban: z.number().int().nonnegative(),
  })
  .strict();

export type ViolationVolumePoint = z.infer<typeof ViolationVolumePointSchema>;

/** The appeals figures — a status a member can only reach from `enforced`. */
export const AppealBreakdownSchema = z
  .object({
    open: z.number().int().nonnegative(),
    upheld: z.number().int().nonnegative(),
    overturned: z.number().int().nonnegative(),
  })
  .strict();

export type AppealBreakdown = z.infer<typeof AppealBreakdownSchema>;

/** The Dashboard's Safety section, violations half (D12). */
export const ViolationStatsSchema = z
  .object({
    window: StatsWindowSchema,
    detected: ComparableCountSchema,
    enforced: z.number().int().nonnegative(),
    appeals: AppealBreakdownSchema,
    perBucket: z.array(ViolationVolumePointSchema),
  })
  .strict();

export type ViolationStats = z.infer<typeof ViolationStatsSchema>;
